import { render } from "./PublicProducts.vue?vue&type=template&id=3b9f1e10&scoped=true"
import script from "./PublicProducts.vue?vue&type=script&lang=js"
export * from "./PublicProducts.vue?vue&type=script&lang=js"

import "./PublicProducts.vue?vue&type=style&index=0&id=3b9f1e10&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9f1e10"]])

export default __exports__